export const Scale = {
	x: (x, areaCenterX, zoomFactor) => (x - areaCenterX) * zoomFactor + areaCenterX,
	y: (y, areaCenterY, zoomFactor) => (y - areaCenterY) * zoomFactor + areaCenterY,
	xInv: (x, areaCenterX, zoomFactor) => (x - areaCenterX) * (1 / zoomFactor) + areaCenterX,
	yInv: (y, areaCenterY, zoomFactor) => (y - areaCenterY) * ( 1 / zoomFactor) + areaCenterY
}
